/**
 * Left bar selectors.
 */
export const isLeftBarOpen = state => state.layout.leftBar !== null;
export const selectLeftBar = state => state.layout.leftBar;
export const isLeftBarModuleOpen = state => state.layout.leftBarModule !== null;
export const selectLeftBarModule = state => state.layout.leftBarModule;
export const getLeftBarModuleExtra = state => state.layout.leftBarModuleExtra;

/**
 * Chat drawer selectors.
 */
export const isChatDrawerOpen = state => state.layout.chatDrawerOpen;

/**
 * Snackbar selectors.
 */
export const selectSnackbarMessage = state => state.layout.snackbarMessage;
